import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.languages.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.languages.actionsLoading;
export const getItems = (state:RootState) => state.languages.items;
export const getItemsSelect = (state:RootState) => state.languages.dropDownItems;
export const getItemsCount = (state:RootState) => state.languages.itemsCount;
export const getItemForEdit = (state:RootState) => state.languages.itemForEdit;
export const getError = (state:RootState) => state.languages.error;
export const getErrorAction = (state:RootState) => state.languages.errorAction;
export const validationErrors = (state: RootState) => state.languages.validationErrors;
